import { render, staticRenderFns } from "./WaitingListDelete.vue?vue&type=template&id=32209042&scoped=true"
import script from "./WaitingListDelete.vue?vue&type=script&lang=js"
export * from "./WaitingListDelete.vue?vue&type=script&lang=js"
import style0 from "./WaitingListDelete.vue?vue&type=style&index=0&id=32209042&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32209042",
  null
  
)

export default component.exports